import * as React from "react"

import { GlobalState } from "../../../../../../store"
import { actionButtonSelector } from "../../../../../resources/adapters"
import { fetchActionButton } from "../../../../../resources/thunks"
import { isNumber } from "../../../../../../util/Strings"
import { useAppDispatch, useAppSelector } from "../../../../../../hooks"

import Button from "../Button"
import UnavailableLink from "../UnavailableLink"
import { ITenForceWindow } from "../../../../../../global"

declare let window: ITenForceWindow

interface Props {
    attributes: Record<string, string>
    internalLink: string
    label: string
    linkParameters: string[]
}

export const ActionButtonInternalLink = ({
    attributes,
    internalLink,
    label,
    linkParameters,
}: Props): JSX.Element => {
    if (
        // make sure it's an internal link we actually support
        ["item", "concept", "collection"].includes(linkParameters[1]) &&
        isNumber(linkParameters[2]) &&
        isNumber(linkParameters[3])
    ) {
        const dispatch = useAppDispatch()
        const resources = useAppSelector(
            (state: GlobalState) => state.resources,
        )
        const actionButton = actionButtonSelector.selectById(
            resources,
            internalLink,
        )

        React.useEffect(() => {
            if (!actionButton) {
                dispatch(fetchActionButton(internalLink))
            }
        }, [])

        if (!actionButton) {
            return (
                <UnavailableLink
                    attributes={attributes}
                    label={label}
                    isLoading={true}
                />
            )
        } else if (actionButton.doesExist && !!actionButton.linkData) {
            const { linkData } = actionButton
            const onClick = (
                event: React.MouseEvent<HTMLButtonElement>,
            ): void => {
                event.stopPropagation()
                // same call is present in ShortcutWidget.tsx
                window.scripting.executeItemScript(
                    linkData.itemId || null,
                    linkData.conceptId || null,
                    linkData.collectionId || null,
                    linkData.scriptId || null,
                    linkData.hasParameters ?? false,
                    null,
                    null,
                    { openResult: true },
                    null,
                    linkData.listScriptId || null,
                )
            }

            return (
                <Button
                    attributes={attributes}
                    label={label}
                    onClick={onClick}
                />
            )
        }
    }

    return <UnavailableLink attributes={attributes} label={label} />
}

export default ActionButtonInternalLink
